import axios from 'axios'
import React, {useState} from 'react'

function MarcasItemDetalle(props) {
  const marca = props.marca

  const API_URL = process.env.REACT_APP_API_URL

  const [principalFile, setPrincipalFile] = useState('')
  const [blancoFile, setBlancoFile] = useState('')
  const [negroFile, setNegroFile] = useState('')
  const [descargableFile, setDescargableFile] = useState('')
  const [nombreInput, setNombreInput] = useState('')
  const [checkOcultar, setCheckOcultar] = useState(marca.ocultar)

  console.log(marca.idElement.split('-'));

  let idElementoNum = marca.idElement.split('-')[1]
  let ocultarElemento = marca.ocultar
  // setCheckOcultar(marca.ocultar)

  const onChangePrincipal = (event) => {
    setPrincipalFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('principal-marcas-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-principal-marca-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeBlanco = (event) => {
    setBlancoFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('blanco-marcas-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-blanco-marca-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeNegro = (event) => {
    setNegroFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('negro-marcas-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-negro-marca-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeNombre = (event) => {
    setNombreInput(event.target.value)
  }

  const onChangeDescargable = (event) => {
    setDescargableFile(event.target.files)
  }

  const onChangeCheckOcultar = (event) => {
    let ocultar = false
    if (event.target.checked) {
      ocultar = 1
    } else {
      ocultar = 0
    }

    setCheckOcultar((current) => !current)

    const data = {
      name: marca.idElement,
      ocultar: ocultar,
    }

    axios.post(API_URL + '/update-marcas-ocultar', data, {}).then(
      (res) => {
        setCheckOcultar(ocultar)
      },
      (error) => {
        alert(error)
      }
    )
  }

  const onSubmit = () => {
    const data = new FormData()

    if (principalFile.length !== 0) {
      for (let i = 0; i < principalFile.length; i++) {
        data.append('file[]', principalFile[i])
      }
      data.append('principalExists', true)
    }

    if (blancoFile.length !== 0) {
      for (let i = 0; i < blancoFile.length; i++) {
        data.append('file[]', blancoFile[i])
      }
      data.append('blancoExists', true)
    }

    if (negroFile.length !== 0) {
      for (let i = 0; i < negroFile.length; i++) {
        data.append('file[]', negroFile[i])
      }
      data.append('negroExists', true)
    }

    if (descargableFile.length !== 0) {
      for (let i = 0; i < descargableFile.length; i++) {
        data.append('descargable[]', descargableFile[i])
      }
      data.append("descargableExists", true)
    }

    data.append('id', marca.id)
    data.append('name', marca.idElement)
    data.append('marcaName', document.getElementById('nombre-marcas-' + idElementoNum).value)

    axios.post(API_URL + '/new-marca', data, {}).then(
      (res) => {
        document.getElementById('ribbon-principal-marca-' + idElementoNum).classList.add('d-none')
        document.getElementById('ribbon-blanco-marca-' + idElementoNum).classList.add('d-none')
        document.getElementById('ribbon-negro-marca-' + idElementoNum).classList.add('d-none')

        document.getElementById('file-principal-marcas-' + idElementoNum).value = null
        document.getElementById('file-blanco-marcas-' + idElementoNum).value = null
        document.getElementById('file-negro-marcas-' + idElementoNum).value = null
        document.getElementById('file-descargable-marcas-' + idElementoNum).value = null
      },
      (error) => {
        alert(error)
      }
    )
  }

  return (
    <div className='col-lg-4 marca-item-detalle mb-10'>
      <label className='form-label mt-6'>Imagen principal: </label>
      <div className='card card-custom overlay overflow-hidden card-principal'>
        <div className='card-body p-0 ribbon'>
          <div
            id={'ribbon-principal-marca-' + idElementoNum}
            className='ribbon-label bg-danger d-none'
          >
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={props.marca.principal}
              alt=''
              className={'w-100 rounder principal-marcas-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-principal-marcas-' + idElementoNum}
                name={'file-principal-marcas-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangePrincipal(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() =>
                  document.getElementById('file-principal-marcas-' + idElementoNum).click()
                }
              />
            </div>
          </div>
        </div>
      </div>

      <label className='form-label mt-6'>Logo blanco: </label>
      <div className='card card-custom overlay overflow-hidden card-blanco'>
        <div className='card-body p-0 ribbon'>
          <div
            id={'ribbon-blanco-marca-' + idElementoNum}
            className='ribbon-label bg-danger d-none'
          >
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={props.marca.logoWhite}
              alt=''
              className={'w-100 rounder blanco-marcas-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-blanco-marcas-' + idElementoNum}
                name={'file-blanco-marcas-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeBlanco(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() =>
                  document.getElementById('file-blanco-marcas-' + idElementoNum).click()
                }
              />
            </div>
          </div>
        </div>
      </div>

      <label className='form-label mt-6'>Logo negro: </label>
      <div className='card card-custom overlay overflow-hidden card-negro'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-negro-marca-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={props.marca.logoBlack}
              alt=''
              className={'w-100 rounder negro-marcas-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-negro-marcas-' + idElementoNum}
                name={'file-negro-marcas-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeNegro(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() =>
                  document.getElementById('file-negro-marcas-' + idElementoNum).click()
                }
              />
            </div>
          </div>
        </div>
      </div>

      <label className='form-label mt-6'>Nombre:</label>
      <input
        id={'nombre-marcas-' + idElementoNum}
        name={'nombre-marcas-' + idElementoNum}
        className='form-control'
        type='text'
        defaultValue={marca.name}
        onChange={(e) => onChangeNombre(e)}
      />

      <div className='row'>
        <div className='form-group col-md-12 mt-2'>
          <label>Subir descargable:</label>
          <input
            type='file'
            className='form-control'
            id={'file-descargable-marcas-' + idElementoNum}
            name={'file-descargable-marcas-' + idElementoNum}
            onChange={(e) => onChangeDescargable(e)}
          />
        </div>
      </div>

      <div className='form-check form-switch form-check-custom form-check-solid mt-8'>
        <input
          className='form-check-input desc-active'
          type='checkbox'
          id='ocultar-header'
          checked={checkOcultar}
          onChange={(e) => onChangeCheckOcultar(e)}
        />
        <label className='form-check-label' for='desc-active'>
          Ocultar de header y footer
        </label>
      </div>

      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
        <button
          className='btn btn-danger float-end btn-sm ms-2'
          onClick={() => props.deleteMarca(marca.idElement)}
        >
          Eliminar
        </button>
      </div>
    </div>
  )
}

export {MarcasItemDetalle}
